import jp from 'jsonpath'
import { PropertyPath } from "./common-types";

export function extractPath(props: any, path: PropertyPath, isMobile?: boolean, elementId?: string) {
    if (!props) return null;

    if (path instanceof Array) {
        let p = props;
        for (let i = 0; i < path.length; i++) {
            p = p[path[i]];
            if (!p) return null;
        }
        return p;
    }
    return props[path];
}

export function addToPath(path: PropertyPath, ...value: Array<string | number>) {
    if (path instanceof Array) {
        return [...path, ...value];
    }
    return [path, ...value];
}
export function applyAtPath(props: any, path: string, value: () => any) {
    let newProps = Object.assign({}, props);
    let parts = path.split('.').filter(x => (x != '$') && !!x);
    if (parts.length == 1) {
        newProps[parts[0]] = value();
        return newProps;
    }
    let currentPos = newProps;
    for (let part of parts.slice(0, -1)) {
        let v = currentPos[part];
        if (typeof v == 'undefined') {
            currentPos[part] = {};
        }
        currentPos = currentPos[part];
    }
    currentPos[parts[parts.length - 1]] = value();
    return newProps;
}
export function injectAtPath(props: any, path: PropertyPath, value: any) {
    if (!props) return null;
    if (!(path instanceof Array)) {
        path = [path];
    }
    if (path instanceof Array) {
        let p = props;
        for (let i = 0; i < path.length - 1; i++) {
            p = p[path[i]];
            if (!p) return null;
        }
        p[path[path.length - 1]] = value;
        return p;
    }
    throw 'Invalid path: ' + JSON.stringify([props, path, value]);
}

export function buildPath(path: PropertyPath) {
    try {
        if (!(path instanceof Array)) {
            path = [path]
        }
        let stringPath = jp.stringify(path as jp.PathComponent[])
        return stringPath
    } catch (error) {
        return null
    }
}
